import { createAction } from 'redux-actions';

export const socketsChangeStatusAction = createAction('SOCKETS/CHANGE_STATUS');
export const socketsResetAction = createAction('SOCKETS/RESET');
